import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useCreateApplication } from '@/api/financial/application/create-application'
import { CreditProductName } from '@/types/customer-context'

/** "Simule" abre a solicitação e entra direto na primeira etapa da jornada. */
export function useStartApplication() {
  const navigate = useNavigate()
  const [error, setError] = useState<string | null>(null)
  const create = useCreateApplication({
    onSuccess: (created) => navigate(`/credit/applications/${created.key}`),
    onError: () =>
      setError(
        'Não foi possível iniciar a solicitação. Você pode já ter uma em andamento.',
      ),
  })

  function start(product: CreditProductName) {
    if (product === 'internship') {
      setError(
        'O Financiamento Estudantil não está disponível para novas solicitações.',
      )
      return
    }

    setError(null)
    create.mutate({ product_name: product })
  }

  return {
    start,
    starting: create.isPending,
    startingProduct: create.isPending
      ? create.variables?.product_name
      : undefined,
    error,
  }
}
